'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SearchIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React__default.default.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 31.714 31.714"
}, props), /*#__PURE__*/React__default.default.createElement("g", {
  transform: "translate(1 1)",
  fill: "none",
  stroke: "inherit",
  strokeLinecap: "round",
  strokeWidth: "2"
}, /*#__PURE__*/React__default.default.createElement("circle", {
  cx: "13.136",
  cy: "13.136",
  r: "13.136"
}), /*#__PURE__*/React__default.default.createElement("path", {
  d: "M22.971 22.971L29.3 29.3"
}))));

exports.default = SearchIcon;
//# sourceMappingURL=magnifying_glass.inline.svg.js.map
